import React, { useState } from 'react';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { customerFocusSalesHistorySelectDisplay } from '../../../actions';

const DisplayFilter = ({placeholder}) => {
    const dispatch = useDispatch()
    const { displaySalesHistorySelected } = useSelector(({customerFocus}) => customerFocus);
    const { langCustomerFocus } = useSelector(({i18nCustomerFocus}) => i18nCustomerFocus);

    const [selected, setSelected] = useState(displaySalesHistorySelected);

    const data = [
        { value: 'itemgroup', label: `${langCustomerFocus.itemGroup}` },
        { value: 'productgroup', label: `${langCustomerFocus.productGroup}` },
        { value: 'productline', label: `${langCustomerFocus.productLine}` },
        { value: 'productcode', label: `${langCustomerFocus.productCode}` }
    ];
    
    const handleChange = (selected) => {
        setSelected(selected)
        dispatch(customerFocusSalesHistorySelectDisplay(selected))
    }

    // const customStyles = {
    //     control: (base, state) => ({
    //       ...base,
    //       width: '150px',
    //       'min-width': '150px'
    //     }),
    // };

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            zIndex: 9999
        }),
    }

    return(
        <Select
            styles={customStyles}
            value={data.find(d => d.value === selected?.value) || null}
            onChange={handleChange}
            options={data}
            placeholder={placeholder}
            />
    );
}

export default DisplayFilter;